export class AssetAssignmentDto {

    assetAssignmentId: number;
    assetLocationId : number;
    assetsId : number;
    employeeId : number;
    employeePhNum : string;
    department: string;
    // checkIn : Date;
    // checkOut: Date;
    isActive: boolean;
    createdUser: string;
    updatedUser: string;
    versionFlag: number;
    checkIn?: Date;
    assetsCode?: string;
    itemName?: string;
    location?: string;
    employeeName?: string;
    plant?: string;
    assetCategory?: string;
    assetType?: string;
    employeeExitDate?:any;
    aging?:string;
    invoiceNo?:string;
    assetSerialNo?:string;
    assetMode?:string;
    requestId?: number

    constructor(
        assetAssignmentId: number,
        assetLocationId : number,
        assetsId: number,
        employeeId : number,
        employeePhNum: string,
        department: string,
        // checkIn : Date,
        // checkOut: Date,
        isActive : boolean,
        versionFlag: number,
        checkIn?: Date,
        assetsCode?: string,
        itemName?: string,
        location?: string,
        employeeName?: string,
        plant?: string,
        assetCategory?: string,
        assetType?: string,
        employeeExitDate?:any,
        aging?:string,
        invoiceNo?:string,
        assetSerialNo?:string,
        assetMode?:string,
        requestId?: number,
    ) {
        this.assetAssignmentId = assetAssignmentId;
        this.assetLocationId = assetLocationId;
        this.assetsId = assetsId;
        this.employeeId = employeeId;
        this.employeePhNum = employeePhNum;
        this.department = department;
        // this.checkIn = checkIn;
        // this.checkOut = checkOut;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
        this.checkIn = checkIn;
        this.assetsCode = assetsCode;
        this.itemName = itemName;
        this.location = location;
        this.employeeName = employeeName;
        this.plant = plant;
        this.assetCategory = assetCategory;
        this.assetType = assetType;
        this.employeeExitDate = employeeExitDate;
        this.invoiceNo = invoiceNo;
        this.assetSerialNo = assetSerialNo
        this.aging = aging;
        this.assetMode = assetMode;
        this.requestId = requestId;
    }
}